// Reverse geocoding via Nominatim (OpenStreetMap). Best-effort: lukt het niet
// (offline, rate limit), dan valt de aanroeper terug op de coördinaten. Zo
// wordt het adres afgeleid uit het kaartpunt in plaats van manueel ingevuld.
type NominatimAddress = {
  road?: string;
  house_number?: string;
  postcode?: string;
  city?: string;
  town?: string;
  village?: string;
  municipality?: string;
};

type NominatimResponse = {
  display_name?: string;
  address?: NominatimAddress;
};

export async function reverseGeocode(lat: number, lng: number): Promise<string | null> {
  try {
    const url =
      `https://nominatim.openstreetmap.org/reverse?format=jsonv2` +
      `&lat=${lat}&lon=${lng}&zoom=18&addressdetails=1`;
    const response = await fetch(url, { headers: { "Accept-Language": "nl" } });
    if (!response.ok) return null;
    const data: NominatimResponse = await response.json();
    const address = data.address;
    if (!address) return data.display_name ?? null;

    const street = [address.road, address.house_number].filter(Boolean).join(" ");
    const city = address.city ?? address.town ?? address.village ?? address.municipality;
    const locality = [address.postcode, city].filter(Boolean).join(" ");
    const parts = [street, locality].filter(Boolean);
    return parts.length > 0 ? parts.join(", ") : (data.display_name ?? null);
  } catch {
    return null;
  }
}
